import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // Initialize i18n
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

// Belt and braces for the public surface's light-ground attribute.
// PublicShell owns data-public-surface and clears it on unmount, and the
// prerenderer strips it from the static files — but build/index.html is the
// SPA fallback for every app route, so a stale artefact from an older deploy
// would otherwise pin a light canvas on /dashboard for the whole session.
// PublicShell re-applies it in useLayoutEffect, before paint.
document.documentElement.removeAttribute('data-public-surface');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
